export default __webpack_public_path__ + "static/media/011-chinese knot.23f7e31c.svg";